import { compose, length, map, prop } from 'ramda';
import { filterFalsy } from 'yafrpl/arrays';

import { clear } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toSize } from '../../mapping/size';
import { image } from '../../partials/image';

/**
 * Transform items to list of processed images
 * @param items
 * @returns list of processed images
 */
const cleanItems = compose(filterFalsy, map(image));

export const coverCarousel = ({ primary, items }) => {
  const content = cleanItems(items);
  if (length(content) >= 3) {
    return clear({
      type: CommonSliceType.COVER_CAROUSEL,
      blocks: content,
      size: toSize(prop('size', primary)),
    });
  }
};
